<div *ngIf="(activeActionItem$ | async).details as document;">
  <div class="tw-p-4">
    <h2>Process Bank Statement</h2>
    <div class="tw-grid tw-grid-cols-[auto_1fr] tw-items-center">
      <div>

        <mat-form-field appearance="outline" floatLabel="always" class="tw-mr-2">
          <mat-label>File Name</mat-label>
          <input
            matInput
            (change)="handleDocNameChange($event)"
            [(value)]="document.filename">
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="tw-mr-2">
          <mat-label>Type</mat-label>
          <mat-select
            [placeholder]="'None'"
            [class]="'no-arrow-transform'"
            (selectionChange)="handleDocCategoryChange($event)"
            [(value)]="document.category">
            <mat-option *ngFor="let category of (documentCategories$ | async)" value="{{category.id}}">{{category.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          *ngIf="documentCategory?.timeClassification === 'month'"
          appearance="outline"
          floatLabel="always">
          <mat-label>For</mat-label>
          <mat-select
            multiple
            [placeholder]="'Select a month'"
            [class]="'no-arrow-transform'"
            [defaultValue]="document.monthsString"
            [(value)]="document.months">
            <mat-option *ngFor="let monthOption of monthOptions;"
                        [value]="formatMonth(monthOption)">
              {{ monthOption }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          *ngIf="documentCategory?.timeClassification === 'year'"
          appearance="outline"
          floatLabel="always">
          <mat-label>Year(s)</mat-label>
          <mat-select
            multiple
            [placeholder]="'Select a year'"
            [class]="'no-arrow-transform'"
            [(value)]="document.years">
            <mat-option *ngFor="let year of yearsOptions;"
                        [value]="year">
              {{ year }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

      <div class="tw-h-8 tw-text-right"
          *appLet="(documentCategory?.timeClassification === 'month' && !document.months?.length) || (documentCategory?.timeClassification === 'year' && !document.years?.length) as missingTime">
        <button
          *ngIf="documentCategory?.name === 'Bank Statement'; else updateDoc"
          mat-flat-button
          [color]="'primary'"
          [disabled]="missingTime || (documentSaving$ | async)"
          (click)="processDocument()">
          <div class="tw-grid tw-grid-flow-col tw-items-center">
            <mat-spinner
              class="tw-text-white tw-mr-2"
              *ngIf="(documentSaving$ | async)"
              diameter="24">
            </mat-spinner>
            <span>Process</span>
          </div>
        </button>
        <ng-template #updateDoc>
          <button
            mat-flat-button
            [color]="'primary'"
            [disabled]="missingTime || (documentSaving$ | async)"
            (click)="updateDocument()">
            <div class="tw-grid tw-grid-flow-col tw-items-center">
              <mat-spinner
                class="tw-text-white tw-mr-2"
                *ngIf="(documentSaving$ | async)"
                diameter="24">
              </mat-spinner>
              <span>Update Document</span>
            </div>
          </button>
        </ng-template>
      </div>

    </div>
  </div>
  <mat-divider></mat-divider>

  <iframe
    appDynamicScreenHeight
    *ngIf="documentUrl"
    width="100%"
    [src]="documentUrl | safeUrl"
  ></iframe>

</div>
